export var slice = Array.prototype.slice;



//////////////////
// WEBPACK FOOTER
// ./~/@swimlane/ngx-charts/~/d3-shape/src/array.js
// module id = 234
// module chunks = 0